import { Http } from '@/lib/http';

export class FinancialReportTypesService extends Http {
  constructor() {
    super();
    this.endpoint = 'settings/general-settings/financial-report-types';
  }

  createFinancialReportType(payload) {
    return this.httpClient().post(`${this.endpoint}`, payload);
  }

  fetchFinancialReportTypes() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  updateFinancialReportType(id, updates) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, updates);
  }

  deleteFinancialReportType(id) {
    return this.httpClient().delete(`${this.endpoint}/${id}`);
  }

}